import { differenceInDays, startOfDay } from "date-fns";

import { useBirthingInformation } from "@/encounters/hooks/useBirthingInformation";

/**
 * Formats the newborn's birth date, birth time, and days since birth for the Newborn IPP encounter.
 *
 * @returns The birth date (`MM/dd/yyyy`), birth time (`hh:mm:ss a`), and calendar days since birth.
 */
export const useNewbornIPPBirthingInformation = () =>
  useBirthingInformation({
    birthTimeFormat: "hh:mm:ss a",
    countDaysSinceBirth: countCalendarDaysSinceBirth,
  });

/**
 * Counts the calendar days between the birth date and today, in local time.
 *
 * @param birthDateTime - The stored birth date-time.
 * @returns The number of midnights passed since birth.
 */
const countCalendarDaysSinceBirth = (birthDateTime: string) =>
  differenceInDays(startOfDay(new Date()), startOfDay(new Date(birthDateTime)));
